import { Injectable, OnDestroy, signal, WritableSignal, inject } from '@angular/core';
import { TransactionsApiService } from '../../../../../_services/transactions-service/transactions-api.service';
import { TransactionCategory } from '../../../../../_interfaces/transactions.interface';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TransactionsService implements OnDestroy {
  protected transactionsApiService = inject(TransactionsApiService);

  readonly subscriptions = new Subscription();
  public categoryOptions: WritableSignal<TransactionCategory[]> = signal<TransactionCategory[]>([]);

  constructor() {
    this.fetchCategories();
  }

  fetchCategories(): void {
    this.subscriptions.add(
      this.transactionsApiService.getTransactionCategoriesList().subscribe({
        next: (res) => {
          this.categoryOptions.set(res);
        },
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
